import AXIOS from "./axios";

export class User {
  static update({
    id,
    name,
    phone_number,
    nickname,
    birthday,
    gender,
    weight,
    blood_type,
    allegies,
    photo,
    height,
    password
  }) {
    if (phone_number && typeof phone_number === "string")
      phone_number = phone_number.replace(/[^a-zA-Z0-9 ]/g, "");
    if (height && typeof height === "string") height = height.replace(" m", "");
    return AXIOS.put(`/users/${id}`, {
      user: {
        name,
        phone_number,
        nickname,
        birthday,
        gender,
        weight,
        blood_type,
        allegies,
        photo,
        height,
        password
      }
    });
  }

  static show(id) {
    return AXIOS.get(`admin/users/${id}`);
  }

  static appointments() {
    return AXIOS.get("admin/users/appointments");
  }

  static verifyEmail({ email }) {
    return AXIOS.post("/users/verify_cpf_email_phone_number", { email });
  }

  static verifyCpf({ cpf }) {
    return AXIOS.post("/users/verify_cpf_email_phone_number", { cpf });
  }

  static verifyPhoneNumber({ phone_number }) {
    return AXIOS.post("/users/verify_cpf_email_phone_number", { phone_number });
  }

  static showSymptoms(payload) {
    return AXIOS.get(`/users/${payload.id}/symptoms`);
  }

  static deleteUser() {
    return AXIOS.delete(`/users/account/destroy`);
  }

  static listPatients() {
    return AXIOS.get(`admin/users/patients`);
  }

  static listInsuranceEnrollments(id) {
    return AXIOS.get(`insurance_enrollments?provider_id=${id}`);
  }
}
